import AddOrEditGodson from './index';
export default AddOrEditGodson;
